export default __webpack_public_path__ + "static/media/pink-arrow.006b035c.svg";